import * as React from "react";
import { Box } from "@mui/material";
import CircularProgress, { circularProgressClasses, CircularProgressProps } from '@mui/material/CircularProgress';

export const AppLoader = ({
  /*  isLoading,*/
    ...rest
}) => {
    // Inspired by the former Facebook spinners.
    function FacebookCircularProgress(props: CircularProgressProps) {
        return (
            <Box sx={{ position: 'relative' }}>
                <CircularProgress
                    variant="determinate"
                    sx={{
                        color: (theme) =>
                            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                    }}
                    size={40}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    sx={{
                        color: (theme) => (theme.palette.mode === 'light' ? '#1976d2' : '#308fe8'),
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0,
                        [`& .${circularProgressClasses.circle}`]: {
                            strokeLinecap: 'round',
                        },
                    }}
                    size={40}
                    thickness={4}
                    {...props}
                />
            </Box>
        );
    }
    return (
            <FacebookCircularProgress />
    );
       
};
